module.exports = __webpack_public_path__ + "img/video_pack.89b3d70e.svg";